import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import t from 'react-translate';

import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { addAlertMessage } from 'redux/actions/alert-messages';
import AnalyticsLoader from './analytics-loader';
import { config } from '@config/config.json';
import { AnalyticsContext } from './analytics-dashboard';
import { AnalyticsDashBoardType } from 'redux/schemas/app/analytics';
import NpsCsatPanel from './nps-csat-stats/nps-csat-panel';

export type QrveyProps = {
  panels?: JSX.Element | null
  renderHeader?: JSX.Element
  showdashboard?: boolean
  isReady?: boolean
};

const QrveyComponent = (props: QrveyProps) => {
  const { isReady, panels, renderHeader, showdashboard = true } = props;
  const {
    dashboardType: type,
    configKeyName = 'config',
  } = useContext(AnalyticsContext);
  const dispatch = useAppDispatch();
  const isLoading = useSelector(state => state.app.qrveyConfig.isLoading);

  if (!config.qrvey?.launcherUrl) {
    dispatch(
      addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.QRVEY.CONFIG_ERROR(),
      }),
    );
  }

  if (!isReady || isLoading) {
    return <AnalyticsLoader />;
  }

  return (
    <>
      {renderHeader && renderHeader}
      {showdashboard && (
        <qrvey-end-user settings={configKeyName} key={configKeyName} />
      )}
      {(type === AnalyticsDashBoardType.QUESTION_SET || type === AnalyticsDashBoardType.COHORT_QUESTION_SET) && <NpsCsatPanel />}
      {panels}
    </>
  );
};

export default QrveyComponent;
